import { Directive, forwardRef, Input, OnChanges } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";

import { OBG_VALIDATORS } from "../validators/validators";

@Directive({
	selector: "[obgNationalId]",
	providers: [
		{
			provide: NG_VALIDATORS,
			// eslint-disable-next-line @angular-eslint/no-forward-ref
			useExisting: forwardRef(() => NationalIdValidatorDirective),
			multi: true,
		},
	],
})
export class NationalIdValidatorDirective implements Validator, OnChanges {
	@Input("obgNationalId") jurisdiction: string | undefined;

	private validator: ((control: AbstractControl) => { nationalId: boolean } | null) | null = null;

	ngOnChanges() {
		this.validator = !this.jurisdiction ? null : OBG_VALIDATORS.nationalId(this.jurisdiction);
	}

	validate(control: AbstractControl): { nationalId: boolean } | null {
		return this.validator && this.validator(control);
	}
}
